import { motion } from "framer-motion";
import { CalendarDays, ArrowRight } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";
import { Button } from "@/components/ui/button";
import { easeOut } from "@/components/common/Reveal";
import { SESSIONS } from "@/data/site";
import { useLead } from "@/components/common/LeadModal";

export default function CalendarSection() {
  const { openLead } = useLead();
  return (
    <section className="bg-slate-50/60 py-24 lg:py-32" data-testid="calendrier">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Calendrier"
          title="Prochaines sessions de formation"
          intro="Consultez nos sessions à venir et réservez votre place. Les dates sont adaptées selon les centres et les effectifs."
        />

        <div className="mt-12 overflow-hidden rounded-2xl border border-slate-200 bg-white">
          {SESSIONS.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, ease: easeOut, delay: i * 0.06 }}
              className="group flex flex-col items-start justify-between gap-4 border-b border-slate-100 p-6 last:border-0 sm:flex-row sm:items-center"
              data-testid={`session-${i}`}
            >
              <div className="flex items-center gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-blue/5 text-brand-blue">
                  <CalendarDays className="h-5 w-5" />
                </div>
                <div>
                  <p className="font-display text-base font-bold text-brand-blue">{s.formation}</p>
                  <p className="text-sm text-slate-500">Centre de {s.centre}</p>
                </div>
              </div>
              <div className="flex items-center gap-6">
                <div className="text-right">
                  <p className="text-sm font-medium text-brand-blue">{s.date}</p>
                  <p className="text-xs text-brand-red">{s.places}</p>
                </div>
                <Button
                  onClick={() => openLead("inscription", { formation: s.formation })}
                  size="sm"
                  className="group rounded-full bg-brand-red hover:bg-brand-red-light"
                  data-testid={`session-cta-${i}`}
                >
                  S'inscrire
                  <ArrowRight className="ml-1 h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
                </Button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
